import React, { useContext } from 'react';
import styled from 'styled-components';
import { isBefore } from 'date-fns';
import { Divider, Title, DatePicker } from 'components';

import { StyledActivateSection } from '../StyledComponents';
import AppointmentDeskContext from '../AppointmentDeskContext';

interface StartDateProps {
  isMlsCovered?: boolean;
}

const StartDate: React.FC<StartDateProps> = ({ isMlsCovered }) => {
  const {
    defaultStartDate,
    selectedStartDate,
    setSelectedStartDate,
    isBoardCovered,
  } = useContext(AppointmentDeskContext);

  return (
    <>
      <StyledDateSection>
        <Title level={3} data-cy="select-date-title">
          Select Start Date
        </Title>
        <StyledDatePicker
          data-cy="answering-service-start-date"
          format="MMMM d yyyy"
          defaultValue={defaultStartDate}
          disabledDate={d => !d || isBefore(d, defaultStartDate)}
          value={selectedStartDate}
          onChange={val => setSelectedStartDate(val)}
          dateRender={current => {
            const date = `${current.getFullYear()}-${
              current.getMonth() + 1
            }-${current.getDate()}`;
            return (
              <div className="ant-picker-cell-inner" data-cy={date}>
                {current.getDate()}
              </div>
            );
          }}
        />
      </StyledDateSection>
      {!isMlsCovered && !isBoardCovered && <Divider />}
    </>
  );
};

const StyledDateSection = styled(StyledActivateSection)`
  padding: 24px 0;
  flex-direction: column;
  align-items: flex-start;
`;

const StyledDatePicker = styled(DatePicker)`
  align-self: stretch;
`;

export default StartDate;
